import axios from "axios";

const token = sessionStorage.getItem("token");

const SERVER_URL =
    process.env.NODE_ENV === "development"
        ? token
            ? "http://localhost:3000/api/v2/"
            : "http://localhost:3000/api/v1/"
        : token
            ? "/api/v2/"
            : "/api/v1/";

// Create an Axios instance
const api = axios.create({
    baseURL: SERVER_URL,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: true,
});

// Add a request interceptor to attach the token
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem("token"); // Retrieve token again in case it changes
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // If access token is invalid/expired and it's the first retry
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            console.log("originalRequest")
            try {
                // Attempt to refresh token using cookie
                const refreshRes = await axios.post(
                    `${SERVER_URL}auth/refresh`,
                    {},
                    { withCredentials: true }
                );
                console.log("refreshRes",refreshRes.data);
                const newToken = refreshRes.data.token;
                console.log("newToken",newToken)
                sessionStorage.setItem("token", newToken);

                // Update and retry original request
                originalRequest.headers.Authorization = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (refreshErr) {
                console.error("Refresh token failed:", refreshErr);
                try {
                    await axios.post("/api/v2/auth/logout");
                } catch (logoutErr) {
                    console.warn("Logout API failed:", logoutErr);
                }
                sessionStorage.clear();
                window.location.href = "/login"; // force logout
                return Promise.reject(refreshErr);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
